import React, { useRef, useCallback } from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import { Template } from 'devextreme-react/core/template';
import { UserMenuSection } from '../user-menu-section/UserMenuSection';


import { ListRef } from 'devextreme-react/list';
import './UserPanel.scss';

export const UserPanel = ({ menuMode, avatarUrl: propAvatarUrl, tenants }) => {
  const avatarUrl = propAvatarUrl || localStorage.getItem('logo');
  const listRef = useRef(null);
  
  const dropDownButtonAttributes = {
    class: 'user-button'
  };

  const buttonDropDownOptions = {
    width: '250px'
  };

  const dropDownButtonContentReady = useCallback(({ component }) => {
    component.registerKeyHandler('downArrow', () => {
      listRef.current?.instance().focus();
    });
  }, [listRef]);

  return (
    <div className='user-panel'>
      {menuMode === 'context' && (
        <DropDownButton stylingMode='text'
          icon={avatarUrl} showArrowIcon={false}
          elementAttr={dropDownButtonAttributes}
          dropDownOptions={buttonDropDownOptions}
          dropDownContentTemplate='dropDownTemplate'
          onContentReady={dropDownButtonContentReady}>
          <Template name='dropDownTemplate'>
            <UserMenuSection listRef={listRef} tenants={tenants} />
          </Template>
        </DropDownButton>
      )}
      {menuMode === 'list' && (
        <UserMenuSection showAvatar tenants={tenants} />
      )}
    </div>
  );
};
